import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";

@Injectable()

export class HistoryService {

    apiUrl: String;
    jwt: String;
    constructor(private http: Http, private appService: AppService) {
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }

    getHistoryList(filterParams: any) {
        const url = this.apiUrl + 'api/cms/history/list';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const params = new URLSearchParams();
        params.append("page", filterParams.page);
        params.append("size", filterParams.size);
        const body = JSON.stringify({});
        return this.http.post(url, body, { headers, params })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }
}


// WEBPACK FOOTER //
// /build/client-cms/src/app/history/history.service.ts